<app-content-modal class="hide-overflow" [title]="'TWO_FACTOR.NEW_PHONE.ADVICE.TITLE'" [buttons]="buttons">
  <div class="u-text-center">
    <img src="assets/imgs/ptrab/contact_coordinator.svg" />
  </div>
  <p>
    {{ 'TWO_FACTOR.NEW_PHONE.ADVICE.SUBTITLE' | mTranslate }}
  </p>
</app-content-modal>
